import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MultiCheckboxField from './MultiCheckboxField';

const MultiCheckboxBridge = ({ name, options, triggers, trigger, triggerIndex, handleChange }) => {
  const getInitialMatchingValue = () => {
    const value = trigger?.matchingValue || '';
    return value.split('|').filter(Boolean);
  };

  const [matchingValue, setMatchingValue] = useState(getInitialMatchingValue());

  const handleConfirm = (_, selectedValues) => {
    const joinedValue = selectedValues.join('|');
    const isDuplicate = triggers.some(
      (t) => t.matcher === trigger.matcher && t.matchingValue === joinedValue,
    );
    if (!isDuplicate) {
      handleChange(name, joinedValue);
    } else {
      setMatchingValue(getInitialMatchingValue());
    }
  };

  useEffect(() => {
    const updatedValue = triggers?.[triggerIndex]?.matchingValue || '';
    setMatchingValue(updatedValue.split('|').filter(Boolean));
  }, [triggers, triggerIndex]);

  return (
    <MultiCheckboxField
      name={name}
      toggleClasses='px-2 py-1 border-grey-1-h-1'
      options={options}
      value={matchingValue}
      handleConfirm={handleConfirm}
    />
  );
};

MultiCheckboxBridge.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  triggers: PropTypes.array,
  trigger: PropTypes.object,
  triggerIndex: PropTypes.number,
};

export default MultiCheckboxBridge;
